import jwt_decode from 'jwt-decode';
import Cookies from 'universal-cookie';

export const registerCookie = (token, expires_in) => {
    const cookies = new Cookies();

    cookies.set('session', token, {
        expires: expires_in,
        path: '/',
        sameSite: 'strict'
    });

    const decoded = jwt_decode(token);
    cookies.set('user', JSON.stringify(decoded), {
        expires: expires_in,
        path: '/',
        sameSite: 'strict'
    });
};

export const registerUser = (data) => {
    const cookies = new Cookies();
    cookies.set('user', data, {
        path: '/',
        sameSite: 'strict'
    });
};

export const getUser = () => {
    const cookies = new Cookies();
    return cookies.get('user');
};
